// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import flipBook from './routes/templateFlipbook';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Flipbook template pages
  flipBook,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

/** TODO: Need to separate this script on its own js file */




// WEBPACK FOOTER //
// ./scripts/main.js